import { render, staticRenderFns } from "./start_training.vue?vue&type=template&id=6bbde210"
import script from "./start_training.vue?vue&type=script&lang=js"
export * from "./start_training.vue?vue&type=script&lang=js"
import style0 from "./start_training.vue?vue&type=style&index=0&id=6bbde210&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports